// extracted by mini-css-extract-plugin
export default {"createpaper":"CreatePaper_createpaper__TpEbH","cp-btn":"CreatePaper_cp-btn__73mSG","btn-sec":"CreatePaper_btn-sec__53+fr","btn":"CreatePaper_btn__5d0KS"};